module.exports = __webpack_public_path__ + "static/media/logo.ab965e99.png";